import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import session from '../../../../share/session';
import util from '../../../../share/util/utils';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../share/util/api/polling';
import { terminate } from './terminate';
import { dispose } from './dispose';
import { PHASE } from './constants';

/**
 * Index取得
 * @param {object} self this インスタンス
 */
export async function read(self) {
  try {
    self.isLoading = true;
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'read'
      },
      // エラー発生のコールバック
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async (result) => { await self.validateErrorResult(result); }
    );

    if (response) {
      self.isSession = response.data?.user_data?.is_session;
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED: {
          const hasDataItems = response.data.user_data.read_results.filter(item => item.has_data);
          if (hasDataItems.length > 0) {
            self.displayedIndexItems = makeDisplayIndex(hasDataItems);
            self.phase = PHASE.INDEX_DISPLAY;
          } else {
            // read_results内にhas_dataがtrueの要素がない場合、履歴なし表示
            await (self.isSession ? terminate : dispose)(self, PHASE.DATA_NON_EXISTENCE);
          }
          break;
        }
        case REQUEST_STATUS_FAILED:
          await self.showIndividualError();
          break;
      }
    }
  } finally {
    self.isLoading = false;
  }
}

/**
 * Index表示項目作成
 * @param {object} readResults 読み出しデータ
 * @returns {object} 
 */
function makeDisplayIndex(readResults) {
  // period_startの昇順に並び替える
  const sorted = readResults.sort((a, b) => {
    return new Date(a.period_start) - new Date(b.period_start);
  });

  // GMTからLocalTimeへ変換
  // 通し番号、選択状態を付与
  let i = 1;
  return sorted.map(item => {
    item.period_start = convertLocalDateTime(item.period_start);
    item.period_end = convertLocalDateTime(item.period_end);
    item.number = i++;
    item.isChecked = false;
    return item;
  });
}

/**
 * GMTからLocalTimeへ変換
 * @param {*} responseDate 絶対時間タイプスタンプ情報
 */
function convertLocalDateTime(responseDate) {
  if (!responseDate) {
    return null;
  }

  const globalDate = new Date(responseDate);

  // LocalTimeに変換
  return util.timeConverter(globalDate);
}